/**
 * The game's slogan stickers — ONE transparent piece per slogan, used in every view that shows it (owner 22.9.2026:
 * "Tilaa kaikki koristesloganit ja muut sticker-elementit siten, että niissä on läpinäkyvä tausta … kaikki slogan-kuvat
 * vaihtoon jos niissä on taustaa mukana, kaikkialla … samalla tarkistus ettei ole tehty samoja elementtejä uudelleen").
 * Four came with the lobby kit, four from Codex on the owner's order; the old residue-cut copies in the view kits are
 * gone. A sticker is placed by left/top/width on the view's own box; the height follows the picture.
 */
import { art } from '../art';

export type Slogan = 'crazier' | 'bigger' | 'vibes' | 'morethan' | 'judgments' | 'together' | 'saynoway' | 'samecrew';
const FILE: Record<Slogan, string> = {
  crazier: '/art/lobby-kit/sticker.ul.png',          // GOOD PEOPLE CRAZIER NIGHTS
  bigger: '/art/lobby-kit/sticker.ur.png',           // SAME PEOPLE BIGGER SITUATIONS
  vibes: '/art/lobby-kit/sticker.r.png',             // GOOD VIBES TOGETHER
  morethan: '/art/lobby-kit/sticker.l.png',          // MORE THAN A GAME
  judgments: '/art/game-theme/sticker.judgments.png', // GOOD JUDGMENTS MAKE GREAT FRIENDS
  together: '/art/game-theme/sticker.together.png',   // SayNoWay Together + the crown face
  saynoway: '/art/game-theme/sticker.saynoway.png',   // SAY NO WAY + crown
  samecrew: '/art/game-theme/sticker.samecrew.png',   // SAME CREW MORE FUN
};
export function Sticker({ slogan, box, z = 12 }: { slogan: Slogan; box: { x: number; y: number; w: number }; z?: number }) {
  return <img class="cut sticker" src={art(FILE[slogan])} alt="" draggable={false} data-sticker={slogan} style={{ position: 'absolute', left: box.x, top: box.y, width: box.w, height: 'auto', zIndex: z, pointerEvents: 'none' }} />;
}
